// extracted by mini-css-extract-plugin
module.exports = {"FetchSpinner":"FetchSpinner_FetchSpinner__RhCGi","spinner":"FetchSpinner_spinner__55RHx","sk-scaleout":"FetchSpinner_sk-scaleout__lTAsM"};